<template>
  <div class="welcome-page">
    <basic-container>
      <div class="welcome-box">
        <img
          class="welcome-bg"
          src="https://joinstech-public.oss-cn-shenzhen.aliyuncs.com/1cc208474f76159630667dcebf3cb8b2"
          alt="欢迎使用慧家云-家居商户运营平台"
        />
      </div>
    </basic-container>
  </div>
</template>

<script>
import { findUserId, findCompany, userInfo } from "@/api/salesCloud/company";
import { setCompany } from "@/util/auth";

export default {
  name: "wel",
  data() {
    return {
      company: "",
      department: "",
      position: "",
      realName: ""
    };
  },
  computed: {},
  created() {
    userInfo().then(res => {
      let data = JSON.parse(res.data);
      this.department = data.department;
      this.position = data.position;
      this.realName = data.realName;
    });
    findUserId().then(res => {
      let data = JSON.parse(res.data);
      console.log(data);
      let userId = data.id;
      findCompany(userId).then(res => {
        this.company = res.data;
        setCompany(res.data);
      });
    });
  },
  methods: {}
};
</script>

<style scoped="scoped" lang="scss">
.welcome-page {
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 150px);
  ::v-deep .basic-container {
    padding: 0 10px 0 0;
    height: 100%;
    background-color: #fff;
  }
  ::v-deep .el-card {
    height: 100%;
    border: none;
    border-radius: 0;
    box-shadow: none;
  }
  ::v-deep .el-card__body {
    height: 100%;
    padding: 0;
    margin: 0;
  }
}
.welcome-box {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 150px);
  background: #fff;
  overflow: hidden;
}
.welcome-bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center center;
}
.info {
  padding: 21px 0;
  display: flex;
  align-items: center;
  .img-border {
    width: 64px;
    height: 65px;
    position: relative;
  }
  .img-v {
    position: absolute;
    bottom: -2px;
    right: -2px;
    width: 22px;
    height: 22px;
  }
  .img {
    border-radius: 5px;
    width: 64px;
    height: 64px;
    display: inline-block;
    overflow: hidden;
    img {
      display: block;
      max-width: none;
      height: 64px;
      opacity: 1;
      width: 64px;
      margin-left: 0px;
      margin-top: 0px;
    }
  }
  .user {
    margin-left: 20px;
    color: rgb(153, 153, 153);
    flex: 1 1 auto;
  }
  .user-img {
    display: flex;
    height: 24px;
    align-items: center;
  }
  .user-title {
    font-size: 18px;
    color: rgb(102, 102, 102);
    margin-right: 5px;
    display: inline-block;
    max-width: 200px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .user-subtitle {
    height: 16px;
    line-height: 16px;
    border-radius: 2px;
    padding: 0px 5px;
    margin-left: 10px;
    font-size: 12px;
    text-align: center;
    color: rgb(255, 44, 84);
    background-color: rgb(255, 242, 244);
    white-space: nowrap;
  }
  .user-item {
    font-size: 12px;
    line-height: 20px;
  }
}
</style>
